<script lang="ts">
  import { find } from 'lodash-es'
  import { imgSrc } from '#app/lib/image_source'
  import { forceArray, getTruthy, isOpenedOutside, loadInternalLink } from '#app/lib/utils'
  import type { ClickEvent } from '#app/types/declarations/svelte'
  import { urlifyImageHash, type SerializedSearchResult } from '#search/lib/search_results'
  import { i18n } from '#user/lib/i18n'
  import { resortSearchResultsHistory, searchResultsHistory, type HistoryEntry } from '../lib/search_results_history'

  let {
    result = $bindable(),
    highlighted,
    onResultSelected,
  }: {
    result: SerializedSearchResult
    highlighted: boolean
    onResultSelected: () => void
  } = $props()

  const uri = getTruthy(result, 'uri')
  const { type, typeAlias, label, description = '', pathname } = result
  const image = getTruthy(result, 'image')

  function addToSearchHistory () {
    if (uri) {
      const pictures = forceArray(image).map(urlifyImageHash.bind(null, type))
      const entry = (find($searchResultsHistory, { uri }) || { uri, label, type, pictures, timestamp: 0 }) as HistoryEntry
      entry.timestamp = Date.now()
      $searchResultsHistory = resortSearchResultsHistory($searchResultsHistory.concat([ entry ]))
    }
  }

  function loadResult (e: ClickEvent) {
    if (!isOpenedOutside(e)) {
      loadInternalLink(e)
      onResultSelected()
    }
  }

  function onclick (e: ClickEvent) {
    addToSearchHistory()
    loadResult(e)
    e.stopPropagation()
  }
</script>

<li class="result" class:highlighted>
  <a
    href={pathname}
    {onclick}
  >
    <div
      class="image"
      style:background-image={image ? `url(${imgSrc(image, 90)})` : ''}
    ></div>
    <span class="type">{i18n(typeAlias)}</span>
    <span class="label">{label}</span>
    <span class="description">{description}</span>
  </a>
</li>

<style lang="scss">
  @import "general/scss/utils";
  .result{
    line-height: 1em;
    position: relative;
    // Prevent triggering horizontal scroll because of too long content
    overflow: hidden;
    &:hover{
      background-color: darken($light-grey, 5%);
    }
    &.highlighted{
      background-color: #666;
      .label{
        color: white;
      }
      .type, .description{
        color: #bbb;
      }
    }
  }
  a{
    @include display-flex(row, center, flex-start);
    color: $dark-grey;
  }
  .image, .type, .label, .description{
    margin-inline-end: 0.5em;
    white-space: nowrap;
    flex: 0 0 auto;
  }
  .description{
    flex: 0 1 auto;
    overflow: hidden;
  }
  .image{
    margin-inline-end: 0.3em;
    width: 48px;
    height: 48px;
    background-size: cover;
    background-position: center center;
  }
  .type, .description{
    color: grey;
    font-size: 0.9em;
  }
</style>
